import PropTypes from 'prop-types';
import { Component } from 'react';
import { get } from 'lodash';
import queryString from 'query-string';

import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import localStore from 'store';

import APP_PATH from '../constants/paths';
import pingAuthenticationQuery from '../graphql/pingAuthenticationQuery';
import { setUser } from '../data/user/actions';
import { fetchFeatureFlags } from '../data/featureFlags/actions';
import { hasRole } from '../utilities/user';
import USER from '../constants/appUser';

class LoginCallback extends Component {
  componentDidMount() {
    const {
      client, history, signInUser, refreshFeatureFlags,
    } = this.props;
    const { code } = queryString.parse(history.location.search);
    localStore.set('authorizationCode', code);
    const user = USER.APP;

    client
      .query({
        query: pingAuthenticationQuery,
        variables: {
          code,
          redirectUri: window.location.origin + APP_PATH.REDIRECT_URL,
          appName: user,
        },
      })
      .then(({ data }) => {
        const error = get(data, 'pingAuthentication.error');
        history.push(APP_PATH.ERROR_PAGE);
        if (error) {
          throw Error(error);
        }
        const accessToken = get(data, 'pingAuthentication.accessToken');
        if (!accessToken) {
          throw Error('Unexpected error');
        }
        const authenticatedUser = get(data, 'pingAuthentication.viewer.user');

        if (hasRole('admin', 'roles')(authenticatedUser)) {
          signInUser(authenticatedUser);
          localStore.set('userId', authenticatedUser.id);
          localStore.set('jwt', accessToken);
          refreshFeatureFlags();
          history.push(APP_PATH.BASE);
        } else {
          throw Error('You are not authorized to view this page.');
        }
      })
      .catch(() => {});
  }

  render() {
    return null;
  }
}

LoginCallback.propTypes = {
  client: PropTypes.shape({
    query: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
    }).isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  signInUser: PropTypes.func.isRequired,
  refreshFeatureFlags: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  signInUser: user => {
    dispatch(setUser(user));
  },
  refreshFeatureFlags: () => {
    dispatch(fetchFeatureFlags());
  },
});

export default compose(
  withApollo,
  withRouter,
  connect(null, mapDispatchToProps)
)(LoginCallback);
